import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';
import { PageDefault } from '../PageDefault'; 

@Component({
    selector: 'team-search',
    templateUrl: 'teamsearch.html' 
})
export class TeamSearch {
    userName = ""; 
    start = PageDefault.endNowDate();
    end = PageDefault.endDate();

    tracks = {};
    constructor(private viewCtrl: ViewController, private navpar: NavParams) { 
        this.userName = navpar.data.userName != undefined ? navpar.data.userName : ""; 
        this.start = navpar.data.startDate != undefined ? navpar.data.startDate : PageDefault.endNowDate();
        this.end = navpar.data.endDate != undefined ? navpar.data.endDate : PageDefault.endDate(); 
    }


    //查询条件
    //TQQ 2017-01-03
    applyFilters() {
        this.tracks["userName"] = this.userName; 
        this.tracks["startDate"] = this.start;
        this.tracks["endDate"] = this.end; 
        this.dismiss(this.tracks)
    }


    //关闭
    //TQQ 2017-01-03
    dismiss(data?: any) {
        this.viewCtrl.dismiss(data);
    }



}


// WEBPACK FOOTER //
// ./src/pages/teamreport/teamsearch.ts